<template>
  <div>
    <div :class="{ 'w-full': onboarding }" class="grid gap-4 max-w-xl mt-2">
      <div>
        <div v-if="!editing">
          <el-input :value="version.label" type="text" disabled class="w-auto"></el-input>
        </div>
        <div v-if="editing && version">
          <el-select v-model="version" placeholder="Select" :class="{ 'w-full': onboarding }" @change="onboarding ? save() : null">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"> </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="mt-4" v-if="!onboarding">
      <el-button v-if="!editing" @click="editing = true" type="primary">Edit Version</el-button>
      <el-button v-if="editing" @click="editing = false; reset()" type="text">Cancel</el-button>
      <el-button v-if="editing" @click="save" type="primary">Save</el-button>
    </div>
  </div>
</template>

<script>
import { PADDLE_VERSION, PADDLE_VERSION_OPTIONS } from '@/store/shared';


export default {
  name: 'PaddleVersion',
  props: {
    paddleVersion: {
      type: String,
      required: true,
    },
    // Special version of this component used in onboarding Paddle connection
    onboarding: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      editing: !!this.onboarding,
      options: PADDLE_VERSION_OPTIONS,
      version: PADDLE_VERSION_OPTIONS[0],
    };
  },
  mounted() {
    this.reset();
  },
  computed: {
    isClassic() {
      return this.version.value === PADDLE_VERSION.CLASSIC;
    },
  },
  methods: {
    reset() {
      this.version = this.options.find((opt) => (opt.value === this.paddleVersion));
    },
    save() {
      this.$emit('save', this.version.value);
      if (!this.onboarding) {
        this.editing = false;
      }
    }
  },
}
</script>
